import React, { useState } from 'react'
import { MessageSquare } from 'lucide-react'

interface Props {
    handleShowChat: () => void
}

export default function ChatButton({ handleShowChat }: Props) {
    const [isVerified, setIsVerified] = useState(() => {
        return sessionStorage.getItem('approval_status') === 'true';
    });

    return (
        <button
            onClick={handleShowChat}
            className="hover:cursor-pointer bg-gray-900 text-white shadow-lg w-12 h-12 flex items-center justify-center rounded-full fixed bottom-8 right-8 z-[60] transition-all hover:scale-105 active:scale-95"
        >
            <MessageSquare size={24} className="" />
        </button>
    )
}
